import { GetterTree } from "vuex";
import { IDemandEditState,  } from "./states.store";
const getters: GetterTree<IDemandEditState, {}> = <GetterTree<IDemandEditState, {}>>{
  service: (state: IDemandEditState) => state.service,
  demand: (state: IDemandEditState) => state.demand,
  demandOrigin: (state: IDemandEditState) => state.demandOrigin,
  demandForCreate: (state: IDemandEditState) => state.demandForCreate,
  isSaving: (state: IDemandEditState) => state.isSaving,
};

export default getters;
